export const GET_FULL_STAT = 'GET_FULL_STAT';



// WEBPACK FOOTER //
// ./src/store/modules/analitics/types.js